import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    debug: false,
    supportedLngs: ['en'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'canvas',
    ns: [],
    react: {
      useSuspense: false
    }
  });

i18n.changeLanguage('en'); // This needs to be removed when Japanese is Enabled.

export default i18n;